<accordion [isAnimated]="true">
  <form class="form-horizontal" [formGroup]="personIncomeInformationForm">
    <accordion-group [isOpen]="true">
      <span accordion-heading>
        <i class='fa fa-money-bill'></i> Información de Ubicación
      </span>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Tipo de Ingreso</b>
          <span appRequiredAsterisk [formGroup]="personIncomeInformationForm" controlName="incomeType"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <ng-select formControlName="incomeType" [items]="filteredIncomeTypes" bindLabel="description" bindValue="code"
            (change)="changeIncomeType($event)" [readonly]="readonly"></ng-select>
        </div>
      </div>
    </accordion-group>
    <div [ngSwitch]="personIncomeInformationForm.value.incomeType">
      <accordion-group [isOpen]="true" *ngSwitchDefault>
        <span accordion-heading class="btn-link text-primary">
          <i class='fa fa-question-circle'></i> Seleccionar un tipo de ingreso
        </span>
      </accordion-group>
      <accordion-group [isOpen]="true" *ngSwitchCase="'Z000'">
        <span accordion-heading>
          <i class='fa fa-money'></i> Asalariado
        </span>
        <app-salaried-income [salariedForm]="getIncomeForm()" [onbaseCatalogue]="onbaseCatalogue" [isEdit]="isEdit"
          [hideStreet]="hideStreet" [readonly]="readonly"
          [isShortFormActiveForPlan]="isShortFormActiveForPlan"></app-salaried-income>
      </accordion-group>
      <accordion-group [isOpen]="true" *ngSwitchCase="'Z001'">
        <span accordion-heading>
          <i class='fa fa-money'></i> Independiente
        </span>
        <app-independent-income [independentForm]="getIncomeForm()" [onbaseCatalogue]="onbaseCatalogue"
          [isEdit]="isEdit" [hideStreet]="hideStreet" [readonly]="readonly"
          [isShortFormActiveForPlan]="isShortFormActiveForPlan"></app-independent-income>
      </accordion-group>
      <accordion-group [isOpen]="true" *ngSwitchCase="'Z002'">
        <span accordion-heading>
          <i class='fa fa-money'></i> Remesas
        </span>
        <app-remittance-income [remittanceForm]="getIncomeForm()" [onbaseCatalogue]="onbaseCatalogue"
          [readonly]="readonly" [isShortFormActiveForPlan]="isShortFormActiveForPlan"></app-remittance-income>
      </accordion-group>
      <accordion-group [isOpen]="true" *ngSwitchCase="'Z003'">
        <span accordion-heading>
          <i class='fa fa-money'></i> Asalariado
        </span>
        <app-salaried-income [salariedForm]="getIncomeForm()" [onbaseCatalogue]="onbaseCatalogue" [isEdit]="isEdit"
          [hideStreet]="true" [hidePhone]="true" [readonly]="readonly"
          [isShortFormActiveForPlan]="isShortFormActiveForPlan"></app-salaried-income>
      </accordion-group>
      <accordion-group [isOpen]="true" *ngSwitchCase="'Z004'">
        <span accordion-heading>
          <i class='fa fa-money'></i> Asalariado
        </span>
        <app-salaried-income [salariedForm]="getIncomeForm()" [onbaseCatalogue]="onbaseCatalogue" [isEdit]="isEdit"
          [readonly]="readonly" [isShortFormActiveForPlan]="isShortFormActiveForPlan"></app-salaried-income>
      </accordion-group>
      <accordion-group [isOpen]="true" *ngSwitchCase="'Z005'">
        <span accordion-heading>
          <i class='fa fa-money'></i> Otros Ingresos
        </span>
        <app-others-income [otherIncomeForm]="getIncomeForm()" [onbaseCatalogue]="onbaseCatalogue" [readonly]="readonly"
          [isShortFormActiveForPlan]="isShortFormActiveForPlan"></app-others-income>
      </accordion-group>
      <accordion-group [isOpen]="true" *ngSwitchCase="'Z006'">
        <span accordion-heading>
          <i class='fa fa-money'></i> Asalariado
        </span>
        <app-salaried-income [salariedForm]="getIncomeForm()" [onbaseCatalogue]="onbaseCatalogue" [isEdit]="isEdit"
          [hideStreet]="hideStreet" [readonly]="readonly"
          [isShortFormActiveForPlan]="isShortFormActiveForPlan"></app-salaried-income>
      </accordion-group>
      <accordion-group [isOpen]="true" *ngSwitchCase="'Z007'">
        <span accordion-heading>
          <i class='fa fa-money'></i> Independiente
        </span>
        <app-independent-income [independentForm]="getIncomeForm()" [onbaseCatalogue]="onbaseCatalogue"
          [isEdit]="isEdit" [hideStreet]="hideStreet" [readonly]="readonly"
          [isShortFormActiveForPlan]="isShortFormActiveForPlan"></app-independent-income>
      </accordion-group>
    </div>
  </form>
</accordion>